import Flickity from 'flickity';

const carousel = new Flickity('#reviews', {
    wrapAround: true,
    autoPlay: true,
    pauseAutoPlayOnHover: true,
    cellAlign: 'left',
});